module.exports = __webpack_public_path__ + "media/images/homelessness-graph-2023-12beb3b0a2b257ee7ad66088b25c55ef.svg";